import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import filesKeys from './keyFactory';

const GetUpload = graphql(`
  query Upload($uploadId: ID!) {
    upload(id: $uploadId) {
      extension
      fileName
      id
      mimeType
      size
      source
      thumbnailUrl
      url
    }
  }
`);

const useGetUpload = (publicId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!publicId,
    queryKey: filesKeys.upload(publicId || ''),
    queryFn: () => {
      return gqlClient.request(GetUpload, { uploadId: publicId || '' });
    },
  });
  return { upload: data?.upload, data, ...rest };
};

export default useGetUpload;
